import { Select } from '@components'
import { type Component, type JSX, Show, createMemo } from 'solid-js'
import { css } from 'styled-system/css'

interface LastSelectDisabledProps {
	selected: string[]
	item: string
	innerTemplate?: (value: string) => JSX.Element
}

export const LastSelectDisabled: Component<LastSelectDisabledProps> = (props) => {
	const isDisabled = createMemo(
		() => props.selected.length === 1 && props.selected[0] === props.item,
	)

	return (
		<Select.Item
			class={css({
				pointerEvents: isDisabled() ? 'none' : 'auto',
				opacity: isDisabled() ? '0.3' : '1',
			})}
			item={props.item}
		>
			<Show
				when={props.innerTemplate}
				fallback={<Select.ItemText>{props.item}</Select.ItemText>}
			>
				{props.innerTemplate!(props.item)}
			</Show>
			<Select.ItemIndicator>✓</Select.ItemIndicator>
		</Select.Item>
	)
}
